import React from 'react';

const SimpleLoader = () => {
  return (
    <div className="min-h-[100dvh] flex items-center justify-center bg-white">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto mb-4"></div>
        <p className="text-gray-600">Loading...</p>
      </div>
    </div>
  );
};

export default SimpleLoader;
